import "./header.scss";
function Header() {
  return (
    <>
      <div className="headerTitleContainer">
        <h1 className="headerTitle">Start your Adventure</h1>
      </div>
    </>
  );
}

export default Header;
